import React from 'react';
import { Box } from '@mui/material';

// Import modular components
import HeroSection from '../components/Homepage/HeroSection';
import FeaturesSection from '../components/Homepage/FeaturesSection';
import StatsSection from '../components/Homepage/StatsSection';
import PoliciesSection from '../components/Homepage/PoliciesSection';
import ContactSection from '../components/Homepage/ContactSection';
import Footer from '../components/Homepage/Footer';

const Homepage: React.FC = () => {

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <HeroSection />
      <FeaturesSection />
      <StatsSection />
      <PoliciesSection />
      <ContactSection />
      <Footer />
    </Box>
  );
};

export default Homepage; 